import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import Link from 'next/link';
import styles from 'sections/Resources/FreightTemplates/PackingList/components/SectionPurpose/SectionPurpose.module.scss';

const cn = classNames.bind(styles);

const SectionPurpose = (): ReactElement => {
  return (
    <section className={cn('purpose')}>
      <div className={cn('container')}>

        <div className={cn('purpose__section')}>

          <div className={cn('purpose__image-box')}>
            <picture>
              <source
                srcSet="
                /images/pages/Resources/FreightTemplates/sign-in.webp 1x,
                /images/pages/Resources/FreightTemplates/sign-in@2x.webp 2x
              "
                sizes="100vw"
              />
              <img
                className={cn('purpose__image')}
                src="/images/pages/Resources/FreightTemplates/sign-in.webp"
                alt="bill of lading"
              />
            </picture>
          </div>

          <div className={cn('purpose__content')}>
            <h2 className={cn('purpose__heading')}>
              <span>Why is the Packing List</span>{' '}
              <span>so important?</span>
            </h2>
            <p className={cn('purpose__paragraph')}>
              It’s all about visibility and handling.
            </p>
            <ul className={cn('purpose__list')}>
              <li className={cn('purpose__list-item')}>
                <span>LCL Shipments:</span>{' '}
                If you are deconsolidating a container, the Packing List tells you which
                box goes to which truck. Without it, you are flying blind.
              </li>
              <li className={cn('purpose__list-item')}>
                <span>Customs Exams:</span>{' '}
                If customs wants to inspect "Item B," a good packing list tells them
                exactly which pallet it’s on. If they have to unpack the whole container 
                to find it, you’re paying for the labor and the delay.
              </li>
              <li className={cn('purpose__list-item')}>
                <span>Safety:</span>{' '}
                It verifies weight distribution so cranes and trucks don't get overloaded.
              </li>
            </ul>
          </div>

        </div>

      </div>
    </section>
  );
};

export default SectionPurpose;